export const CHANGE_TOTAL_PRE_TAX = 'receipt/change_total_pre_tax'

export const CHANGE_TAX_COST = 'receipt/change_tax_cost'

export const CHANGE_TIP_COST = 'receipt/change_tip_cost'

export const ADD_ITEM = 'receipt/add_item'

export const REMOVE_ITEM = 'receipt/remove_item'



/** WEBPACK FOOTER **
 ** ./src/core/receipt/action-types.js
 **/